import { useTranslations } from 'next-intl';
import { Button } from 'src/components/design-system';
import { useCopyToClipboard } from '../../../../../hooks';

interface Props {
  referralCode: string;
}

export default function Code(props: Props): JSX.Element {
  const t = useTranslations('loyalty');
  const { status, copy } = useCopyToClipboard();

  return (
    <div>
      <h3 className="tw-mb-3 tw-text-xl tw-text-center tw-text-gray-500">
        {t('wallet.referral.modal.yourCode')}
      </h3>

      <div className="tw-flex tw-justify-between tw-content-center tw-p-2 tw-rounded-xl tw-border">
        <div className="tw-text-3xl tw-font-bold tw-pl-2 tw-pr-4 tw-leading-10 tw-text-gray-700">
          {props.referralCode}
        </div>

        <Button
          className={
            status === 'copied'
              ? 'tw-bg-gradient-to-rb tw-from-success tw-to-success hover:tw-from-success hover:tw-to-success tw-cursor-default'
              : ''
          }
          onClick={() => copy(props.referralCode)}
        >
          {t(`wallet.referral.modal.${status}`)}
        </Button>
      </div>
    </div>
  );
}
